import { render, staticRenderFns } from "./PreviewOrder.vue?vue&type=template&id=47047052&scoped=true&"
import script from "./PreviewOrder.vue?vue&type=script&lang=js&"
export * from "./PreviewOrder.vue?vue&type=script&lang=js&"
import style0 from "./PreviewOrder.vue?vue&type=style&index=0&id=47047052&prod&lang=scss&scoped=true&"
import style1 from "./PreviewOrder.vue?vue&type=style&index=1&id=47047052&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47047052",
  null
  
)

export default component.exports